import { Schema } from 'rsuite';
import { State, isCodeTaken } from './partnerCreateFormState';

const { StringType } = Schema.Types;

const MAX_CODE_LENGTH = 50;
const MAX_PARTNER_NAME_LENGTH = 50;
const CODE_TAKEN_MESSAGE = 'Partner code is already used by another partner.';

export function getPartnerCodeErrorMessage(state: State): string | undefined {
  return isCodeTaken(state) ? CODE_TAKEN_MESSAGE : undefined;
}

const validationModel = Schema.Model({
  code: StringType()
    .isRequired('Partner code is required.')
    .maxLength(MAX_CODE_LENGTH, `Max ${MAX_CODE_LENGTH} characters.`),

  partnerName: StringType()
    .isRequired('Partner name is required.')
    .maxLength(MAX_PARTNER_NAME_LENGTH, `Max ${MAX_PARTNER_NAME_LENGTH} characters.`),

  integration: StringType().isRequired('Integration is required.'),
});

export default validationModel;
